import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrganizationalUnitOptionResource } from "../../types/organizationalUnit";
import { OrganizationalUnitMultiSelectField } from "../../ui/OrganizationalUnitMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
	title: string;
}

export const AccordionItemOrganizationalUnits: FC<Props> = ({ name, title }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<OrganizationalUnitOptionResource[]>(name);
	const { organizationalUnits, organizationalUnitsIsLoading, renderOrganizationalUnitsAsCheckboxes } =
		useEventFilterAccordionItems();

	if (!organizationalUnits || !organizationalUnits.length) {
		return null;
	}

	const renderBody = () => {
		if (organizationalUnitsIsLoading) return <Loading />;
		if (renderOrganizationalUnitsAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{organizationalUnits.map((organizationalUnit) => (
						<FilterCheckbox
							key={`${organizationalUnit.id}`}
							name={`${name}-${organizationalUnit.id}`}
							value={value.some((v) => v.id === organizationalUnit.id)}
							label={organizationalUnit.name}
							onChange={(e) =>
								setValue(
									e.target.value ? [...value, organizationalUnit] : value.filter((v) => v.id !== organizationalUnit.id),
								)
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <OrganizationalUnitMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={title}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
